import React, { useState, useEffect, useCallback } from 'react';
import Map from '../Map';
import OfficeSelector from './OfficeSelector';
import useWindowSize from '../../hooks/UseWindowSize';

const CompanyMapContainer = ({ locations, contact }) => {
  const [selectedOffice, setSelectedOffice] = useState(null);
  const { width } = useWindowSize();
  const isMobile = width < 768;

  useEffect(() => {
    if (locations && locations.length > 0) {
      const headquarters = locations.find(loc => loc.headquarters);
      const defaultOffice = headquarters || locations[0];
      const defaultIndex = locations.indexOf(defaultOffice);
      
      setSelectedOffice({
        ...defaultOffice,
        index: defaultIndex
      });
    }
  }, [locations]);

  const handleOfficeSelect = useCallback((office, index) => {
    setSelectedOffice({
      ...office,
      index
    });
  }, []);

  const mapCenter = React.useMemo(() => {
    return selectedOffice?.geometry?.coordinates 
      ? [selectedOffice.geometry.coordinates[1], selectedOffice.geometry.coordinates[0]]
      : undefined;
  }, [selectedOffice?.geometry?.coordinates]);

  const geoJSON = {
    type: "FeatureCollection",
    features: locations
      .filter(loc => loc.geometry && loc.geometry.coordinates)
      .map((loc, index) => ({
        type: "Feature",
        geometry: loc.geometry,
        properties: {
          id: `office-${index}`,
          index: index,
          isActive: selectedOffice?.index === index,
          isSelected: selectedOffice?.index === index,
          isHeadquarters: loc.headquarters,
          link: "#",
          name: `${loc.location_city}, ${loc.location_country?.label}`,
          email: contact?.contact_email,
          employee: loc.location_size?.label,
          phone: loc.location_phone,
          address: `${loc.location_street}, ${loc.location_city}, ${loc.location_country?.label}${loc.location_zip ? ', ' + loc.location_zip : ''}`,
          about: `${loc.location_street}, ${loc.location_city}, ${loc.location_country?.label}`
        }
      }))
  };

  if (isMobile) {
    return (
      <OfficeSelector
        locations={locations}
        selectedOffice={selectedOffice}
        onOfficeSelect={handleOfficeSelect}
      />
    )
  }

  return (
    <div className="company-map-container position-relative">
      <div className="map-wrapper-450">
        <Map
          className="h-100 map-full"
          center={mapCenter}
          zoom={16}
          popupVenue
          selectedOfficeId={selectedOffice?.index}
          geoJSON={geoJSON}
          persistentPopup={true}
          autoOpenPopup={true}
          smoothTransition={true}
        />
      </div>
      
      {/* Overlay Office Selector */}
      <div className="office-selector-overlay position-absolute top-0 start-0 m-2 m-md-3" style={{ zIndex: 1000 }}>
        <OfficeSelector
          locations={locations}
          selectedOffice={selectedOffice}
          onOfficeSelect={handleOfficeSelect}
        />
      </div>
    </div>
  );
};

export default CompanyMapContainer;
